import { Icons } from "../assets/icons";
import { IRouteConfig } from "../models/IRouteConfig";
import Pages from "../pages";
import HealthCheck from "../routes/HealthCheck";
import NotFound from "../routes/NotFound";

const routesConfig: IRouteConfig[] = [
  {
    path: "/healthcheck",
    element: <HealthCheck />,
    children: [],
  },
  {
    path: "/",
    element: <Pages.LandingPage />,
    children: [],
  },
  {
    path: "/about",
    element: <Pages.AboutPage />,
    name: "About Lilly ExploR&D",
    icon: <Icons.IconAbout />,
    children: [],
  },
  {
    path: "/capabilities",
    element: <Pages.CapabilitiesPage />,
    name: "Our Capabilities",
    icon: <Icons.IconCapabilities />,
    children: [],
  },
  {
    path: "/testimonials",
    element: <Pages.TestimonialsPage />,
    name: "Testimonials",
    icon: <Icons.IconTestinonials />,
    children: [],
  },
  {
    path: "/contact",
    element: <Pages.ContactPage />,
    name: "Contact Us",
    icon: <Icons.IconContact />,
    children: [],
  },
  {
    path: "/sitemap",
    element: <Pages.Sitemap />,
    children: [],
  },
  {
    path: "*",
    element: <NotFound />,
    children: [],
  },
];

export { routesConfig };
